import { fetchPost, fetchGet } from 'common';

const apiUri: string = process.env.REACT_APP_API_URI as string;

export const searchDocumentImagesService = (body: any, bearerToken: string) =>
  fetchPost(`${apiUri}/xosdocumentsimage/search`, body, bearerToken);

export const fetchStatesService = (bearerToken: string) =>
  fetchGet(`${apiUri}/documentimages/states`, bearerToken);

export const fetchDriversService = (
  statehob: string,
  countyhob: string,
  cmtdocId: string,
  bearerToken: string,
) =>
  fetchGet(
    `${apiUri}/documentimages/drivers/${statehob}/${countyhob}/${cmtdocId}`,
    bearerToken,
  );

export const fetchXDetailsService = (
  statehob: string,
  countyhob: string,
  cmtdocId: string,
  bearerToken: string,
) =>
  fetchGet(
    `${apiUri}/documentimages/xdetails/${statehob}/${countyhob}/${cmtdocId}`,
    bearerToken,
  );

export const fetchLicenseFlag = (user: string, bearerToken: string) =>
  fetchGet(`${apiUri}/authentication/license/${user}`, bearerToken);
